module.exports = __webpack_public_path__ + "media/assets/box-over-box-7e1ce998dca8366a3d38a02008a5ba2b.svg";